import Head from "next/head";
import { wrapper } from "@/redux/Store";

import FAQ from "@/containers/StaticPages/FAQ";
import { renderMetaData } from "@/utils";
const FAQPage = () => {
  const metaData = {
    title: "FAQs",
    description: "FAQs",
  };

  const metaTags = renderMetaData(metaData);
  return (
    <>
      {metaTags}
      <main>
        <FAQ />
      </main>
    </>
  );
};

export default FAQPage;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24 * 15, // revalidate in 15 days
  };
});
